class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.hoverTimer;
    this.leaveTimer;
    this.mainDetailsToggle = this.querySelector("details");
    this.childSummary = this.mainDetailsToggle.querySelector("summary");
    this.childContent = this.mainDetailsToggle.querySelector(
      ".mega-menu__content",
    );
    this.childSummarySub =
      this.mainDetailsToggle.querySelector(".header__submenu");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.hideOnMouseleave =
      this.mainDetailsToggle.querySelector(".hide-on-focus-out");

    // this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));

    this.childSummary.addEventListener("mouseenter", (event) => {
      if (this.childSummary.classList.contains("header__menu-item") || this.childSummary.classList.contains("header__cta-link")) {
        this.hoverTimer = setTimeout(() => {
          this.childSummary.closest("details").setAttribute("open", true);
        }, 250);
        this.lastScrollY = window.scrollY;
        window.addEventListener("scroll", this.handleScroll, { passive: true });
      }
    });

    this.childSummary.addEventListener("mouseleave", (event) => {
      clearTimeout(this.hoverTimer);

      this.leaveTimer = setTimeout(() => {
        if (event.relatedTarget && event.relatedTarget.classList) {
          if (
            !event.relatedTarget.classList.contains("global-settings-popup")
          ) {
            this.onFocusOut();
          }
        }
      }, 250);
    });

    if (this.childContent != null) {
      this.childContent.addEventListener("mouseenter", (event) => {
        clearTimeout(this.leaveTimer);
      });

      this.childContent.addEventListener("mouseleave", (event) => {
        if (event.relatedTarget != this.childSummary) {
          this.onFocusOut();
        }
      });
    }

    if (this.childSummarySub != null) {
      this.childSummarySub.addEventListener("mouseenter", (event) => {
        clearTimeout(this.leaveTimer);
      });
    }

    if (this.hideOnMouseleave != null) {
      this.hideOnMouseleave.addEventListener("mouseenter", (event) => {
        clearTimeout(this.leaveTimer);
      });
      this.hideOnMouseleave.addEventListener("mouseleave", (event) => {
        if (event.relatedTarget != this.childSummary) {
          this.onFocusOut();
        }
      });
    }

    this.handleScroll = this.handleScroll.bind(this);
    this.lastScrollY = window.scrollY;
  }

  onFocusOut() {
    setTimeout(() => {
      // if (!this.contains(document.activeElement))
      this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  handleScroll() {
    const currentScrollY = window.scrollY;
    // Close only if scrolling up or down
    if (
      currentScrollY > this.lastScrollY ||
      currentScrollY < this.lastScrollY
    ) {
      this.close();
      window.removeEventListener("scroll", this.handleScroll);
    }
    this.lastScrollY = currentScrollY;
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    window.removeEventListener("scroll", this.handleScroll);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }
}

customElements.define("header-menu", HeaderMenu);
